import { spawn } from 'redux-saga/effects';
import { logErroneousActions } from '~/store/errorLogger/errorLogger.watcher.sagas';

export function* errorLoggerSagas() {
  yield spawn(logErroneousActions);
}
